import { inject } from '@angular/core';
import { ResolveFn } from '@angular/router';
import { RegistroEvaluacionService } from '../services/registro-evaluacion.service';
import { RegistroEvaluacion } from '@/app/models/interface/registro-evaluacion.model';

export const registroResolver: ResolveFn<RegistroEvaluacion> = (
  route,
  state,
) => {
  const service = inject(RegistroEvaluacionService);

  const id = route.paramMap.get('registroId');

  return service.findOne(id ? id : '');
};
